import { useWindowStore } from 'modules/desktop/pages/MainPage/stores'
import { useLocation } from 'react-router-dom'
import { WindowState } from 'shared/types'
import { IframeAppInstance } from 'shared/types/index'

export interface UseAppButtonStateReturn {
  hasOpenWindow: boolean
  isMinimized: boolean
  isActive: boolean
  isExpanded: boolean
  isFocused: boolean
  currentAppWindow: WindowState | undefined
}

export const useAppButtonState = (
  app: IframeAppInstance
): UseAppButtonStateReturn => {
  const currentPath = useLocation().pathname
  const windows = useWindowStore(state => state.windows)
  const activeWindowId = useWindowStore(state => state.activeWindowId)

  const hasOpenWindow = windows.some(
    window => window.id === app.id && window.isVisible
  )

  const isMinimized = windows.some(
    window => window.id === app.id && window.isMinimized
  )

  const isActive = currentPath.startsWith(
    (app.url || '').replace(process.env.REACT_APP_CONTAINER_DOMAIN!, '')
  )

  const isFocused = activeWindowId === app.id

  const isExpanded = hasOpenWindow || isActive

  const currentAppWindow = windows.find(window => window.id === app.id)

  return {
    hasOpenWindow,
    isMinimized,
    isActive,
    isExpanded,
    isFocused,
    currentAppWindow
  }
}
